import {t} from "@lingui/core/macro";
import React from "react";

interface Props {
    // A base64 encoded image.

    image: string;
    // Optional alt-text for the image.  Ideally this is a brief description
    // of the image, generated by the ai-guide service.
    // Falls back to a generic message if no alt text is provided.
    altText?: string;
    // Optionally, a width in pixels.
    displayWidth?: number;
    // Optionally, a height in pixels.
    displayHeight?: number;
}

export function ImagePreview({
    image,
    altText,
    displayWidth = 128,
    displayHeight = 128,
}: Props): React.ReactElement {
    const width = displayWidth + "px";
    const height = displayHeight + "px";

    return (
        <img
            src={image}
            alt={
                altText
                    ? t`Thumbnail of attached image: ${altText}`
                    : t`Attached image thumbnail`
            }
            height={height}
            width={width}
            // If the dimensions of the image don't match our display tile, then
            // crop the image to fit the entire tile area.
            style={{objectFit: "scale-down"}}
            aria-live="polite"
        />
    );
}
